var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMastercard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 37,
  height: 24,
  viewBox: "0 0 37 24",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF5F00",
  d: "M23.335 3.354h-9.632v17.287h9.632V3.354Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#EB001B",
  d: "M14.315 11.998c0-3.36 1.56-6.567 4.19-8.644C13.733-.402 6.822.423 3.061 5.217-.698 9.982.127 16.884 4.928 20.641a10.99 10.99 0 0 0 13.607 0 10.995 10.995 0 0 1-4.22-8.643Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F79E1B",
  d: "M36.33 11.997c0 6.078-4.922 10.995-11.007 10.995-2.477 0-4.862-.825-6.788-2.352 4.77-3.756 5.595-10.658 1.834-15.453-.55-.672-1.162-1.314-1.834-1.833 4.77-3.756 11.71-2.932 15.441 1.863a10.874 10.874 0 0 1 2.355 6.78Zm-1.039 6.811v-.367h.153v-.06h-.367v.06h.153v.367h.061Zm.704 0v-.428h-.123l-.122.306-.122-.306h-.123v.428h.092v-.336l.122.275h.092l.122-.275v.336h.062Z"
})));
export { SvgMastercard as ReactComponent };
export default __webpack_public_path__ + "cdb1e4f113abba00833e1558094002f696e13c12329c8908834469127a58de7c.svg";